import React from "react";
import { connect } from 'react-redux';

import { Typography, Paper } from '@material-ui/core';

import { setSurveyAnswer } from '../../../actions/surveyActions';

class SurveyPageSingleQuestions extends React.Component {
    checkIfSelectedAnswer(option) {
        return (option !== null) && this.props.surveyData.currentAnswer && this.props.surveyData.currentAnswer.find( item => item === option);
    }

    onSelectAnswer(value) {
        let currentAnswer = this.props.surveyData.currentAnswer;
        if (currentAnswer && currentAnswer.length > 0 && value === currentAnswer[0]) {
            this.props.setSurveyAnswer(null);
        }else {
            this.props.setSurveyAnswer([value]);
        }
    }

    render() {
        return (
            <>
                <Typography classes={{root: "survey-instructions"}}>
                    {this.props.translations["SURVEY.OPTIONS_SINGLE_HEADING"]}
                </Typography>

                <div className="survey-options-container">
                    {this.props.surveyData.currentQuestionObject.choices.map(item => (
                        <Paper key={item.order} classes={{root: "survey-options-wrapper"}} order={item.order} value={item.value.toString()} className={this.checkIfSelectedAnswer(item.value) ? "selected-answer" : ""} onClick={ () => this.onSelectAnswer(item.value) }>
                            <Typography classes={{root: "survey-options-text"}}>
                                {item.text}
                            </Typography>
                        </Paper>
                    ))}
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        surveyData : state.surveyData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSurveyAnswer: (ans) => {dispatch(setSurveyAnswer(ans))}
    }
}
    
export default connect(mapStateToProps, mapDispatchToProps)(SurveyPageSingleQuestions);